import React, { useState } from 'react';
import './Consultancy_fb.css';
import { Backtotop, Underline,Alertmessage } from "../../widgets";
import { consultancyFeedbackQuestions } from "../../constants/feedbackQuestions";
import axios from 'axios';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const Consultancy_fb = () => {
  
  const [department, setDepartment] = useState('');
  const [companyOffering, setCompanyOffering] = useState('');
  const [natureOfWork, setNatureOfWork] = useState('');
  const [dateOfCommencement, setDateOfCommencement] = useState('');
  const [programme, setProgramme] = useState('');
  const [ratings, setRatings] = useState({});
  const [ratingErrors, setRatingErrors] = useState({});
  const [dateError, setDateError] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const validateDate = (dateVal) => {
    const currDate=new Date();
    const date=new Date(dateVal);
    return date<=currDate; 
  };

  const validateRatings = () => {
    const errors = {};
    consultancyFeedbackQuestions.forEach(({ name }) => {
      if (!ratings[name]) {
        errors[name] = 'Please select a rating (தயவுசெய்து மதிப்பீட்டை தேர்வு செய்யவும்)';
      }
    });
    setRatingErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleRatingChange = (e, name) => {
    setRatings(prevRatings => ({
      ...prevRatings,
      [name]: e.target.value
    }));
    setRatingErrors(prevErrors => ({
      ...prevErrors,
      [name]: ''  
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    

    const isDateValid = true;
    // const isDateValid = validateDate(dateOfCommencement);
    
    const areRatingsValid = validateRatings();

    if (!isDateValid) {
      setDateError('Please enter a valid date.');
      return;
    } else {
      setDateError('');
    }

    if (!areRatingsValid) {
      return;
    }
// alert(dateOfCommencement);

    try {
      const response = await axios.post('/backend/consultancy_ratingsubmit', {
        work_undertaking_dept: department,
        company_offering: companyOffering,
        nature_of_work: natureOfWork,
        date_of_commencement: dateOfCommencement,
        programme: programme,
        ratings: ratings
      });

      console.log(response.data);
      setAlertMessage("Feedback submitted successfully");

    
      setDepartment('');
      setCompanyOffering('');
      setNatureOfWork('');
      setDateOfCommencement('');
      setProgramme('');
      setRatings({});
      setRatingErrors({});
    } catch (error) {
      console.error('Error:', error);
      setAlertMessage("An error occurred while submitting your ratings");
    }
  };
  const handleCloseAlert = () => setAlertMessage('');

  const Departments = ["Civil","Mech","EEE","ECE","CSE"];
  const NatureOfWorks = ["Testing","Fabrication","Trouble Shooting and Services","Educational Services","Auditing","Software Development","Debugging and Testing","Others"];
  const programmes = ["B.E","M.E","PhD"];
  return (
    <div className="consultancy_fb_container">
      <Underline heading="Consultancy Feedback" />

      <form className="consultancy_fb_form" onSubmit={handleSubmit}>
        <div className="consultancy_fb_row">
           <Autocomplete
              disablePortal
              options={Departments}
              sx={{ width: "50%",marginBottom:"15px" }}
              onChange={(event, newValue) => setDepartment(newValue || "")}
              renderInput={(params) => <TextField {...params} label="Department Underdtaking the work" required />}                      
          />
          <TextField
                className="consultancy_fb_input"
                label="Company Offering Consultancy*"
                variant="outlined"
                value={companyOffering}
                onChange={(e) => setCompanyOffering(e.target.value)}                              
            />
        </div>
        <div className='consultancy_fb_row'>
           <Autocomplete
              disablePortal
              options={NatureOfWorks}
              sx={{ width: "50%",marginBottom:"15px" }}
              onChange={(event, newValue) => setNatureOfWork(newValue || "")}
              renderInput={(params) => <TextField {...params} label="Nature of Work" required />}                      
          />
            <TextField
                className="consultancy_fb_input"
                label="Date of Commencement*(YYYY-MM-DD)"
                variant="outlined"
                value={dateOfCommencement}
                onChange={(e) => setDateOfCommencement(e.target.value)}                              
            />
          {/* {dateError && <p className='consultancy_fb_error' id='consultancy_date_err'>{dateError}</p>} */}
        </div>
        <div className="consultancy_fb_row"> 
           <Autocomplete
              disablePortal
              options={programmes}
              sx={{ width: "100%",marginBottom:"15px" }}
              onChange={(event, newValue) => setProgramme(newValue || "")}
              renderInput={(params) => <TextField {...params} label="Select Programme" required />}                      
          />
        </div>

        <h2 className="consultancy_fb_subtitle">Please give your valuable feedback on a scale</h2>
        <div className="consultancy_fb_feedback">
          <br />

          {consultancyFeedbackQuestions.map(({ question, translation, name }) => (
            <div className="consultancy_fb_question" key={name}>
              <div className="consultancy_fb_qr">
                <p className='consultancy_fb_qr_p'>{question}</p>  
                <p className='consultancy_fb_qr_p'>({translation})</p>
              </div>

              <div className="consultancy_fb_ratings">
                {['Low', 'Medium', 'High'].map((label, index) => (
                  <label key={index}>
                    <input 
            type="radio" 
            name={name} 
            value={label.toLowerCase()} 
            checked={ratings[name] === label.toLowerCase()} 
            onChange={(e) => handleRatingChange(e, name)} 
          />
                    <span className="consultancy-custom-radio"></span>
                    {label}
                  </label>
                ))}
              </div>
              {ratingErrors[name] && <p className='consultancy_fb_error'>{ratingErrors[name]}</p>}
            </div>
          ))}
        </div>

        <div className="consultancy_fb_btn">
          <button type="submit" className="consultancy_fb_submit">
            Submit
          </button>
        </div>
      </form>
      <Backtotop />
      <Alertmessage message={alertMessage} onClose={handleCloseAlert} /> 
    </div>
  );
};

export default Consultancy_fb;
